export const PROFILE_LIST = {
  PERSONAL_DATA: "البيانات الشخصية",
  ADDRESS: "العنوان",
  SECURITY_CODE: "تغيير رمز الأمان",
  MEANS_OF_RECEIVING: "وسائل الإستلام",
  SETTINGS: "الإعدادات",
};
